module.exports = __webpack_public_path__ + "img/2.b8e80981.jpg";